export function createUmedida() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    ClaveErp: '',
    EsActivo: true,
    Descripcion: '',
    Tipo: '',
    ClaveSAT: '',
    NombreSAT: '',
    Orden: 0,
    Notas: ''
  };
}
